import { z } from "zod";

import { dateStringToDate } from "../components/utils/dateStringToDate";

const splosnoFormSchema = z
  .object({
    naziv: z.string().min(3, { message: "Naziv projekta je obvezen podatek" }),
    akronim: z.string().optional(),
    sifra: z.string().optional(),
    zacetek: z.preprocess(
      (val) => {
        return dateStringToDate(val);
      },
      z.date({ message: "Začetek projekta mora biti veljaven datum" }),
    ),
    konec: z.preprocess(
      (val) => {
        return dateStringToDate(val);
      },
      z.date({ message: "Konec projekta mora biti veljaven datum" }),
    ),
    pogodba: z.string().optional(),
    referencnaSt: z.string().optional(),
    spletnaStran: z.string().optional(),
    deminimis: z.boolean().nullable().optional(),
    sodGopodarstvom: z.boolean().nullable().optional(),
    sodStudenti: z.boolean().nullable().optional(),
    stStudenti: z.number().int().optional().nullable(),
    enakostSpolov: z.boolean().nullable().optional(),
    povzetek: z.string().optional(),
    obcanskaZnanost: z.boolean().nullable().optional(),
    obcanskaZnanostKrovniProjekt: z.boolean().nullable().optional(),
    obcanskaZnanostSelectedProjekt: z
      .object({
        value: z.number(),
        label: z.string(),
      })
      .optional()
      .nullable(),
    razpisSelected: z.object({
      value: z.number(),
      label: z.string(),
    }),
    cerifID: z.number().optional().nullable(),
    arrsID: z.number().optional().nullable(),
    klasiusID: z.number().optional().nullable(),
  })
  .superRefine(({ zacetek, konec }, ctx) => {
    if (!zacetek || !konec) return;

    if (zacetek > konec) {
      ctx.addIssue({
        message: "Začetek projekta je večji od konca projekta",
        path: ["zacetek"],
      });
    }
    if (konec < zacetek) {
      ctx.addIssue({
        message: "Konec projekta je manjši od začetka projekta",
        path: ["konec"],
      });
    }
  })
  .superRefine(
    ({ obcanskaZnanostKrovniProjekt, obcanskaZnanostSelectedProjekt }, ctx) => {
      if (obcanskaZnanostKrovniProjekt && !obcanskaZnanostSelectedProjekt) {
        ctx.addIssue({
          message: "Potrebno je izbrati krovni projekt",
          path: ["obcanskaZnanostSelectedProjekt"],
        });
      }
    },
  );

export default splosnoFormSchema;
